<input
  [type]="props.type"
  [formControl]="formControl"
  [formlyAttributes]="field"
  class="form-control field-focus"
  [ngClass]="props.inputClass"
  [attr.data-testing-id]="field.key"
/>
